
/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import AppRoutes from "./AppRoutes";
import getCurrentPosition from "components/reusable/GetCurrentPosition";
import { updateIsSupportPWA } from "reducers/logoutPersist";
/* Project Import will be here */

/* Styles will be here */
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/styles/app.css";
import "assets/styles/responsive.css";
import "assets/styles/horizontal-scroll.css";
import "font-awesome/css/font-awesome.css";
import "assets/styles/custom-antd.css";
import "assets/styles/ant-override.css";
import 'react-circular-progressbar/dist/styles.css';
/* Styles will be here */

const lightenThemeColor = (color, amount) => {
  return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

if (window.themeColorCode !== "" && (/^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(window.themeColorCode))) {
  document.documentElement.style.setProperty('--primary-color', window.themeColorCode);
  document.documentElement.style.setProperty('--theme-hover-color', lightenThemeColor(window.themeColorCode, 30));
  document.documentElement.style.setProperty('--quality-btn-color', lightenThemeColor(window.themeColorCode, 210));
  document.documentElement.style.setProperty('--lite-theme-color', lightenThemeColor(window.themeColorCode, 240));
  document.documentElement.style.setProperty('--lite-secondary-theme-color', lightenThemeColor(window.themeColorCode, 190));
  document.documentElement.style.setProperty('--ex-lite-secondary-theme-color', lightenThemeColor(window.themeColorCode, 240));
}

class App extends Component {
  /* Update the PWA support event in common reducer  */
  updateIsSupportPWA = (event) => {
    event.preventDefault();
    this.props.actions.updateIsSupportPWA(event, true);
  };

  addInstalled = () => {
    this.props.actions.updateIsSupportPWA(null, false);
  }

  componentDidMount = () => {
    /* Get the browser PWA support event and update */
    window.addEventListener("beforeinstallprompt", this.updateIsSupportPWA);
    window.addEventListener("appinstalled", this.addInstalled);

    this.props.actions.getCurrentPosition();

    /* Disable right click option in PWA to prevent image download from PWA */
    document.addEventListener("contextmenu",
      function (e) {
        if (e.target.nodeName === "IMG") {
          e.preventDefault();
        }
      }, false);

    /* Close the popup when the browser back button clicked */
    window.addEventListener('popstate', event => {
      const elements = document.getElementsByClassName("ant-modal-root");
      while (elements.length > 0) elements[0].remove();
    });
  }

  render() {
    return (<AppRoutes />);
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        getCurrentPosition,
        updateIsSupportPWA
      },
      dispatch
    ),
  };
};

export default connect(null, mapDispatchToProps)(App);